"use client";

import { c as _c } from "react/compiler-runtime";
import { HStack } from "@navikt/ds-react";
import { useParams } from "next/navigation";
import { useRef } from "react";
import { knappKlikket } from "@/common/analytics/events-and-properties/knappKlikket-properties";
import { TrackedButton } from "@/ui/TrackedButton";
import { LagNyPlanModal } from "../LagNyPlanModal";
import { VisPdfButtonAG } from "./VisPdfButtonAG";
interface Props {
  planId: string;
  hasUtkast: boolean;
}
export function AktivPlanButtons(t0) {
  const $ = _c(9);
  const {
    planId,
    hasUtkast
  } = t0;
  const {
    narmesteLederId
  } = useParams();
  const lagNyPlanModalRef = useRef(null);
  let t1;
  if ($[0] !== hasUtkast) {
    t1 = <LagNyPlanModal ref={lagNyPlanModalRef} hasUtkast={hasUtkast} />;
    $[0] = hasUtkast;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TrackedButton variant="secondary" onClick={() => lagNyPlanModalRef.current?.showModal()} tracking={knappKlikket.aktivPlanSide.lagNyOppfolgingsplanModalTrigger}>Oppdater planen</TrackedButton>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== narmesteLederId || $[4] !== planId) {
    t3 = <HStack justify="space-between">{t2}<VisPdfButtonAG narmesteLederId={narmesteLederId} planId={planId} /></HStack>;
    $[3] = narmesteLederId;
    $[4] = planId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}